module.exports = __webpack_public_path__ + "static/10-52b2acce3f89952f5e6290e676bbdd24.jpeg";